import Vue from 'vue';

Vue.filter('myfnodblquotes', value => {

  var ret = value;

  if (ret != null) {
    ret = ret.split('"').join('');
  }
  return ret;

});

Vue.filter('myfzeroniejedentak', value => {

  if (value == "0") return 'Nie';
  if (value == "1") return 'Tak';
  return 'b.d.';

});

Vue.filter('myfzeronieemptyniejedentak', value => {

  if (value == "0") return 'Nie';
  if (value == "1") return 'Tak';
  return 'Nie';

});

Vue.filter('myfjedenzaplminus1niezapl', value => {

  if (value == -1) return 'NIE ZAPŁ.';
  if (value == 1) return 'ZAPŁ.';
  return '';

});

Vue.filter('myfplaceholderforemptyvalue', value => {

  //console.log(value);
  if (value == "" || value==null) return "(pole jest puste, kliknij aby edytować (1))";
  return value;

});

Vue.filter('urltoproddevel', value => {

  if (value.toString().includes('len.')) return 'DEVEL';
  return 'PRODUKCJA';

});

Vue.filter('usertypeinttostring', value => {

  if (value == 1) return 'admin';
  if (value == 2) return 'klient';


});